import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getGoalTypesGraphqlPayload, getGoalTypesURL } from './utils';
export var queryGoalTypes = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _response$errors, _response$data$townsq, _response$data;
    var containerId, _ref$gatewayBaseUrl, gatewayBaseUrl, siteUrl, url, request, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          containerId = _ref.containerId, _ref$gatewayBaseUrl = _ref.gatewayBaseUrl, gatewayBaseUrl = _ref$gatewayBaseUrl === void 0 ? '' : _ref$gatewayBaseUrl, siteUrl = _ref.siteUrl;
          url = gatewayBaseUrl !== null && gatewayBaseUrl !== void 0 ? gatewayBaseUrl : siteUrl;
          _context.next = 4;
          return fetch(getGoalTypesURL({
            gatewayBaseUrl: url
          }), {
            method: 'post',
            credentials: 'include',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: getGoalTypesGraphqlPayload({
              containerId: containerId
            })
          });
        case 4:
          request = _context.sent;
          _context.next = 7;
          return request.json();
        case 7:
          response = _context.sent;
          if (!(((_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : _response$errors.length) > 0)) {
            _context.next = 10;
            break;
          }
          throw new Error('Unable to query for goal types');
        case 10:
          return _context.abrupt("return", (_response$data$townsq = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.townsquare.goalTypes) !== null && _response$data$townsq !== void 0 ? _response$data$townsq : []);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function queryGoalTypes(_x) {
    return _ref2.apply(this, arguments);
  };
}();